export const DISMISS_REASON_LABELS = {
  not_applicable: "Not applicable",
  already_covered: "Already covered",
  clinical_judgement: "Clinical judgement",
  will_do_later: "Will do later",
  dismissed: "Dismissed",
};

export function formatPathwayDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export function getPathwayEvalDotColor(item) {
  if (item?.status !== "completed") return null;
  if (item?.is_evaluation_overdue) return "danger";
  if (item?.is_evaluation_due_soon) return "warning";
  return null;
}

export function getPathwayAccentTone(item) {
  const desc = String(item?.description || "").toLowerCase();
  if (desc.includes("flagged") || desc.includes("concern")) return "terra";

  if (item?.action === "review") return "warning";
  if (item?.status === "dismissed") return "none";
  if (item?.status === "completed") {
    if (item?.is_evaluation_overdue) return "danger";
    if (item?.is_evaluation_due_soon) return "warning";
    return "success";
  }
  if (item?.status === "overdue") return "danger";
  if (item?.status === "due") return "warning";
  if (item?.status === "suggested") return "ai";
  return "pending";
}

export function getPathwayStatusTone(item) {
  if (item?.action === "review") return "warning";
  if (item?.status === "completed") return "success";
  if (item?.status === "overdue") return "danger";
  if (item?.status === "due") return "warning";
  return "muted";
}

export function getPathwayToolScoreTone(item) {
  if (item?.template_type !== "tool") return null;
  if (item?.score === null || item?.score === undefined) return null;

  const label = String(
    item.score_band || item.score_category || "",
  ).toLowerCase();
  const matches = (...keys) => keys.some((k) => label.includes(k));

  if (matches("high", "severe", "very high")) return "danger";
  if (matches("medium", "moderate", "at risk", "at-risk")) return "warning";
  if (matches("low", "independent", "no risk")) return "success";
  return "neutral";
}

export function getPathwayToolScoreLabel(item) {
  const trailing = item?.score_band || item?.score_category;
  return trailing
    ? `Score: ${item.score} · ${trailing}`
    : `Score: ${item.score}`;
}

export function getPathwaySubtitle(item) {
  if (item?.action === "review" && item?.governance_item_title) {
    return `Review: ${item.governance_item_title}`;
  }
  if (item?.status === "completed" && item?.action !== "review") {
    if (item?.is_evaluation_overdue && item?.next_evaluation_date) {
      return `Evaluation overdue since ${formatPathwayDate(item.next_evaluation_date)}`;
    }
    if (item?.is_evaluation_due_soon && item?.next_evaluation_date) {
      return `Evaluation due ${formatPathwayDate(item.next_evaluation_date)}`;
    }
    if (
      item?.next_evaluation_date &&
      !item?.is_evaluation_overdue &&
      !item?.is_evaluation_due_soon
    ) {
      return "Evaluation up to date";
    }
    if (item?.completed_at) {
      return `Completed ${formatPathwayDate(item.completed_at)}`;
    }
    return "Completed";
  }
  if (item?.status === "overdue" && item?.due_date) {
    return `Overdue since ${formatPathwayDate(item.due_date)}`;
  }
  if (item?.status === "due" && item?.due_date) {
    return `Due ${formatPathwayDate(item.due_date)}`;
  }
  if (item?.status === "suggested") {
    return "Suggested by AI pathway";
  }
  if (item?.governance_item_title && item?.status !== "completed") {
    return item.governance_item_title;
  }
  return item?.description || item?.phase || null;
}

export function getPathwaySubtitleTone(item) {
  if (item?.status === "overdue" || item?.is_evaluation_overdue)
    return "danger";
  if (item?.is_evaluation_due_soon || item?.status === "due") return "warning";
  if (
    item?.next_evaluation_date &&
    item?.status === "completed" &&
    !item?.is_evaluation_overdue &&
    !item?.is_evaluation_due_soon
  ) {
    return "success";
  }
  return "muted";
}

export function showPathwayAiBadge(item) {
  return (
    item?.node_type === "onboarding" ||
    item?.action === "review" ||
    item?.source === "ai" ||
    item?.is_ai_suggested ||
    item?.status === "suggested"
  );
}

export function isPathwayClickable(item) {
  if (item?.status === "dismissed") return false;
  return (
    Boolean(item?.template_id) &&
    (item?.action === "review" ||
      ["pending", "suggested", "due", "overdue", "completed"].includes(
        item?.status,
      ))
  );
}
